import { getConsent } from './consent';
let initialized=false;
let analyticsMode=null;
export const trackEvent = (name, params = {}) => {
  if (typeof window === "undefined" || getConsent() !== "accepted") return;
  window.dataLayer = window.dataLayer || [];
  if (analyticsMode === "ga4" && typeof window.gtag === "function") {
    window.gtag("event", name, params);
  } else {
    window.dataLayer.push({ event: name, ...params });
  }
};

export const trackPageView = (path, title) => {
  trackEvent("page_view", {
    page_location: `${window.location.origin}${path}`,
    page_path: path,
    page_title: title || document.title,
  });
};

export const openCallbackModal = () => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event("open-callback"));
};

export const initAnalytics = () => {
  if (typeof window === "undefined" || getConsent() !== "accepted" || initialized) return;
  initialized=true;
  const gtmId = process.env.REACT_APP_GTM_ID;
  const gaId = process.env.REACT_APP_GA_ID || "G-D27HDZ8C3X";

  if (gtmId) {
    analyticsMode="gtm";
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    document.head.appendChild(s);
  }

  if (!gtmId && gaId) {
    analyticsMode="ga4";
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    // Pages vues envoyées explicitement : une seule mesure par page, y compris à l'arrivée.
    window.gtag("config", gaId, { send_page_view: false });
  }

  trackPageView(`${window.location.pathname}${window.location.search}`, document.title);
};
